import { Component, OnInit, ViewChild, ElementRef,Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../../admin.service';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
    MatDialog,
    MAT_DIALOG_DATA,
    MatDialogRef,
  } from '@angular/material/dialog';
@Component({
    selector: 'app-banner-list',
    templateUrl: './banner.list.component.html',
    styleUrls: ['./banner.list.component.css', './deactivate-reschedule.css']
})

export class BannerList implements OnInit {
    bannerFilterType = "allBanner"
    allBannerList : any;
    allBannerListForShow : any;
    selectedBannerId = '';
    selectedBannerDetails : any;
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    ngOnInit(): void {
        this.getAllBanners()
    }
    constructor(private adminService : AdminService,private _snackBar: MatSnackBar,private _matDialog: MatDialog){}


    selectedBanner(bannerId){
        this.selectedBannerId = bannerId
        let banner = this.allBannerList.find(banner => banner.banner_schedule_id === bannerId)
        this.selectedBannerDetails = {
            id : banner.banner_schedule_id,
            imageLink : banner.banner_image.url,
            startTime : banner.start_time,
            endTime : banner.end_time,
            status: banner.status,
            botName: banner.bot.name,
            type: banner.type,
            url: banner.url
        }
    }
    getAllBanners(){
        this.adminService.getAllBannerForBannerHub().subscribe(
            (res)=>{
                this.allBannerList = res.data;
                this.allBannerListForShow = res.data;
                if( this.allBannerList.length > 0){
                  this.selectedBannerId = this.allBannerList[0].banner_schedule_id;
                  this.selectedBanner(this.selectedBannerId);
                }
                
            },
            (err)=>{
                let message = err.error.message ? err.error.message : "Something Went Wrong in Fetching Banner"
                this._snackBar.open(message, 'close', {
                    duration: 3000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                });
            }
        )
    }

    filterBannerByStatus(type){
        if(type=='ALLBANNER'){
            this.allBannerListForShow = this.allBannerList; 
        } else {
            this.allBannerListForShow = this.allBannerList.filter((banner)=>{
                return banner.status == type;
            })
        }
        if( this.allBannerListForShow.length > 0){
            this.selectedBannerId = this.allBannerListForShow[0].banner_schedule_id;
            this.selectedBanner(this.selectedBannerId);
          }
        
    }
    deactivateBanner(selectedBanner){
        const dialogRef = this._matDialog.open(DeactivateBannerDialog, {
            data:{selectedBanner}
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result.data?.isDeactivated) {
              this.getAllBanners();
              this._snackBar.open("Successfully Deactivated", 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
              })
            }
        })
    }
    rescheduleBanner(selectedBanner){
        const dialogRef = this._matDialog.open(RescheduleBannerDialog, {
            data:{selectedBanner}
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result.data?.isRescheduled) {
              this.getAllBanners();
              this._snackBar.open("Successfully Rescheduled", 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
              })
            }
        })
    }
}
@Component({
    selector: 'app-deactivate-list',
    templateUrl: './deactivate-banner.html',
    styleUrls: ['./banner.list.component.css', './deactivate-reschedule.css']
})
export class DeactivateBannerDialog{
    id = ''
    title = ''
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    constructor(public dialogRef: MatDialogRef<DeactivateBannerDialog>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private adminService: AdminService, private _snackBar: MatSnackBar) {
        this.title = data.selectedBanner.botName
        this.id = data.selectedBanner.id
    }
    closePopUp(){
        this.dialogRef.close();
    }
    deactivateBanner(){
        this.adminService.deactivateBanner(this.id).subscribe(
            (res) => {}, 
            (err)=>{
                if(err.status==200){
                    this.dialogRef.close({
                        event: 'close',
                        data: {
                          isDeactivated:true
                        }
                    });
                }
                else{
                    let message = err.error.message ? err.error.message : "Something Bad Occured"
                    this._snackBar.open(message, 'close', {
                    duration: 3000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                   });
                }
            }
        )
    }
}
@Component({
    selector: 'app-reschedule-list',
    templateUrl: './reschedule-banner.html',
    styleUrls: ['./banner.list.component.css', './deactivate-reschedule.css']
})
export class RescheduleBannerDialog{
    id = ''
    startTime = ''
    endTime = ''
    startDateForm = new FormControl();
    endDateForm = new FormControl();
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    title = ''
    minEndDate = new Date()
    constructor(public dialogRef: MatDialogRef<RescheduleBannerDialog>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private adminService: AdminService, private _snackBar: MatSnackBar) {
        this.id = data.selectedBanner.id
        this.title = data.selectedBanner.botName
        this.startDateForm.setValue(data.selectedBanner.startTime)
        this.endDateForm.setValue(data.selectedBanner.endTime)
        this.startTime = new Date(data.selectedBanner.startTime).toLocaleTimeString('en-US', { hour12: false });
        this.endTime = new Date(data.selectedBanner.endTime).toLocaleTimeString('en-US', { hour12: false });
    }
    closePopUp(){
        this.dialogRef.close();
    }
    convertInFormatTime(selectedDate, time) {
        const dateValue = new Date(selectedDate);
        const timeValue = time;
        let [hours, minutes] = timeValue.split(':');
        dateValue.setHours(parseInt(hours, 10), parseInt(minutes, 10));
        const formattedDate = dateValue.toISOString();
        return formattedDate;
    }
    timeToMillisecond(time) {
        let [hours, minutes] = time.split(':');
        let milliSecond = (parseInt(hours, 10) * 60 + parseInt(minutes, 10)) * 60 * 1000;
        return milliSecond;
    }
    rescheduleBanner(){
      let start_time = this.timeToMillisecond(this.startTime);
      let end_time = this.timeToMillisecond(this.endTime);
      let start_date = new Date(this.startDateForm.value).getTime() + start_time;
      let end_date = new Date(this.endDateForm.value).getTime() + end_time;
      if(start_date>end_date){
        this._snackBar.open("Start Time is Less than End Time", 'close', {
                duration: 4000,
                horizontalPosition: 'end',
                verticalPosition: 'top',
            });
            return;
        }
      let reqBody={
       start_time: this.convertInFormatTime(this.startDateForm.value, this.startTime),
       end_time: this.convertInFormatTime(this.endDateForm.value, this.endTime),
      }
      this.adminService.rescheduleBanner(reqBody,this.id).subscribe(
        (res) => {}, 
        (err)=>{
            if(err.status==200){
                this.dialogRef.close({
                    event: 'close',
                    data: {
                      isRescheduled:true
                    }
                });
            }
            else{
                let message = err.error.message ? err.error.message : "Something Went Wrong"
                this._snackBar.open(message, 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
               });
            }
        }
     )
    }

}

